import { faSlashForward } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Breadcrumbs as BreadcrumbsSixUi } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { BreadcrumbsAction } from './BreadcrumbsAction';
import { BreadcrumbsText } from './BreadcrumbsText';

export type IBreadcrumbsProps = IContainerProps & {
  children: React.ReactNode;
};

const styles = stylex.create({
  host: {
    display: 'inline-flex',
    minHeight: 42,
    maxWidth: 'calc(100vw - 48px)',
    alignItems: 'center',
  },
  breadcrumbs: {
    gap: '0.125rem',
    paddingLeft: '0.25rem',
    paddingRight: '0.75rem',
  },
  separator: {
    color: colorSchemeTokens.onSurfaceVariant,
  },
});

const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ children, ...props }) => (
  <ContentBlock sx={[styles.host, props.sx ?? null]}>
    <BreadcrumbsSixUi
      aria-label="breadcrumb"
      separator={<FontAwesomeIcon icon={faSlashForward} size="xs" />}
      sx={styles.breadcrumbs}
      showTrailingSeparator
    >
      {children}
    </BreadcrumbsSixUi>
  </ContentBlock>
);

const BreadcrumbsNamespace = Object.assign(Breadcrumbs, {
  Text: BreadcrumbsText,
  Action: BreadcrumbsAction,
});

export { BreadcrumbsNamespace as Breadcrumbs };
